import { ListPage } from '@mgrvtechgroup/admin-ds';
import type { ReactNode } from 'react';

/** 목록 위 안내 한 줄 — 툴바와 같은 좌우 여백에 맞춘다. */
export function ListNote({ children }: { children: ReactNode }) {
  return (
    <ListPage.Summary>
      <p className="caption text-muted-foreground py-2" aria-live="polite">
        {children}
      </p>
    </ListPage.Summary>
  );
}

/**
 * DataTable 빈 상태를 헤더 왼쪽 가장자리에 맞추는 래퍼 클래스.
 * DS 표 셀의 px-8과 Empty의 p-6 때문에 안내 문구가 표 가장자리에서 3.5rem 안쪽으로 들어가는 것을 보정한다.
 */
export const TABLE_BODY_CLASS =
  'flex min-h-0 flex-1 flex-col [&_[data-slot=empty-header]]:!w-full [&_[data-slot=empty-header]]:!max-w-[calc(100cqi-3.5rem)] [&_[data-slot=empty-header]]:!items-start [&_[data-slot=empty-header]]:!text-left [&_[data-slot=empty]]:!items-start [&_[data-slot=empty]]:!text-left [&_[data-slot=table-container]]:[container-type:inline-size]';
